import View from "../../../Nav/Js/views/common/TabbedListView";
import components from "./components.js";
components.define("js-TabbedList", View);